import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SelectOptions from "@/components/inputs/SelectOptions.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'GenderSelection',
  props: {
},
  setup(__props) {



const gender = [
    { id: '1', label: 'Male', value: 'Male'},
    { id: '2', label: 'Female', value: 'Female'},
    { id: '3', label: 'Prefer not to say', value: 'Prefer not to say'}
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectOptions, {
    name: "gender",
    id: "gender",
    label: "Gender",
    options: gender
  }))
}
}

})